// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  RegattaGroupRatingType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputNumber,
  InputSwitch,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import {
  regattaGroupRatingTypeLabel,
} from 'common.language';

// Types
type $Props = $Translate & {
  item: $Model<'RegattaGroup'> | $ModelUpsertParams<'RegattaGroup'>;
  resourceData: Array<$Model<'Group'>>;
};

const RegattaGroupFieldsView = function ({
  item,
  resourceData,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col sm={7}>
          <AvField
            label={t('Group')}
            name={'GroupId'}
            required
            type={'select'}
            value={item.GroupId}
          >
            {item.GroupId === '' && (
              <option />
            )}
            {_.map(
              resourceData,
              (i) => (
                <option
                  key={i.id}
                  value={i.id}
                >
                  {i.Name}
                </option>
              ),
            )}
          </AvField>
        </Col>
        <Col sm={5}>
          <AvField
            label={t('Rating type')}
            name={'RatingType'}
            required
            type={'select'}
            value={item.RatingType}
          >
            {_.map(
              RegattaGroupRatingType,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(regattaGroupRatingTypeLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Alternative title')}
            name={'AltName'}
            value={item.AltName}
          />
        </Col>
      </Row>
      <Row>
        <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
          {t('Max entries in group quantity')}
          <InputNumber
            className={'mb-0-i w-25'}
            name={'EntriesQuantityLimit'}
            value={item.EntriesQuantityLimit}
          />
        </Col>
      </Row>
      <Row>
        <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
          {t('Max crewmembers in entry quantity')}
          <InputNumber
            className={'mb-0-i w-25'}
            name={'CrewQuantityLimit'}
            value={item.CrewQuantityLimit}
          />
        </Col>
      </Row>
      <Row>
        <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
          {t('Show preliminary crewmember quantity field')}
          <InputSwitch
            name={'PreliminaryCrewQuantityEnabled'}
            value={item.PreliminaryCrewQuantityEnabled}
          />
        </Col>
      </Row>
      <Row>
        <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
          {t('Collect coach data')}
          <InputSwitch
            name={'CoachEnabled'}
            value={item.CoachEnabled}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaGroupFieldsView;
